import React from 'react';
import Header from '../components/Header';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useParams } from "react-router-dom";
import Text from '../components/LanguageText';
import CircularProgress from '@material-ui/core/CircularProgress';

// URL for API
const URL = 'https://quiz5ll-server.herokuapp.com';
// const URL = 'http://localhost:8080';
//const URL = '';

let initialScores = [
    {
        name: 'proximity',
        score: -1
    },
    {
        name: 'recognition',
        score: -1
    },
    {
        name: 'purpose',
        score: -1
    },
    {
        name: 'connection',
        score: -1
    },
    {
       name: 'mentoring',
       score: -1
    }
];
function Result() {
    const [scores, setScores] = React.useState([]);

    const { id } = useParams();
    // call once
    if (scores.length === 0) {
        // get quiz results
        fetch(`${URL}/result/${id}`, {
            method: 'get',
        })
        .then(res => res.json())
        .then(
            (r) => {
                initialScores.forEach((row) => {
                    row.score = r.result[row.name];
                });
                const sortedScores = initialScores.sort((a, b) => b.score - a.score);
                setScores(sortedScores)
            },
            (error) => {
                console.log('ERROR', error);
            }
        )
    }
    if (scores.length === 0) {
        return (
            <>
                <Header />
                <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
                    <CircularProgress disableShrink />
                </div>
            </>
        )
    }
    
    return (
        <>
            <Header/>
            <div className="instructions">
                <div className="container">
                    <Grid container direction="column">
                        <Grid item xs={12}>
                            <div style={{ fontSize: '29px', fontWeight: '300', marginBottom: '20px', marginTop: '20px' }}>
                                Your top leadership language is <b>{scores[0].name.charAt(0).toUpperCase() + scores[0].name.slice(1)}</b>
                            </div>
                            <Typography variant="subtitle1">
                                <p>
                                    <b>The highest score below is your primary leadership language (12 is the maximum score possible). This shows how you like leaders to relate to you and the way you tend to lead others, yourself.</b>
                                </p>
                            </Typography>
                            <Typography variant="subtitle1">
                                <p>
                                    As a leader, your primary language is how you seek to improve the morale of your people, show them appreciation, and develop their trust in you. As a follower, your primary language indicates how a leader can best build your motivation, deepen trust, and convey appreciation so it is meaningful to you. It's common to have two high scores, although one language is usually higher for most people.
                                </p>
                                <p>
                                    The lower scores indicate those languages which are less meaningful to you. These don't likely affect you very much on an emotional level.
                                </p>
                                <p>
                                    Be aware, it's possible for your Leadership Language to change over the course of your career depending on your professional circumstances.
                                </p>
                            </Typography>
                            <Typography variant="caption">
                                <b>NOTE:</b> This page can be bookmarked to return to your results at a later time.
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="container">
                <Grid container spacing={8} direction="row">
                    <Grid item xs={12} sm={8}>
                        {
                            scores.map((row, index) => {
                                return (
                                    <div key={index} className="container">
                                        <div className="instructions" style={{ padding: '10px', marginTop: '10px' }}><Text language={row.name} score={row.score} num={index + 1} /></div>
                                    </div>
                                );
                            })
                        }
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ marginTop: '20px' }} >
                        <Typography variant="h6">
                            <b>Important to remember</b>
                        </Typography>
                        <Typography variant="body2">
                            <p>
                                Be sure to pay attention to the Leadership Languages you scored lower in. These may be the highest scores for the people you lead. Understanding their language, and how different it is from yours, can help you learn what truly motivates them without the guesswork. It also reduces misunderstanding.
                            </p>
                            <p>
                                In the same way, if you have someone who manages you, it is important to share with them your preferred Leadership Language, so they don't have to guess what motivates you and builds trust.
                            </p>
                            <p>
                                Every time we speak the language of another person, we score emotional and motivational points. This translates into...
                            </p>
                            <p>
                                <ul>
                                    <li>
                                        Better communication
                                    </li>
                                    <li>
                                        Increased productivity
                                    </li>
                                    <li>
                                        Fewer misunderstandings
                                    </li>
                                    <li>
                                        Greater employee retention
                                    </li>
                                    <li>
                                        More trust
                                    </li>
                                    <li>
                                        Enjoyment at work
                                    </li>
                                </ul>

                            </p>

                            <p style={{ fontStyle: 'italic' }}>
                                All of these benefits roll straight to the bottom line.
                            </p>
                            <p>
                                If you have not already done so, encourage your coworkers, manager, and direct reports to take <b>The 5 Leadership Languages™</b> Quiz. Discuss your respective Leadership Languages and use this insight to get results.
                            </p>
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default Result;
